import { ReactNode } from "react";

import Footer from "./Footer";
import Header from "./Header";
import { useSidebarContext } from "@/contexts/SidebarContext";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { useRouter } from "next/router";
import { useModal } from "@/contexts/ModalContext";
import { useGlobalLoading } from "@/contexts/Loading";
import Loader from "@/components/Loader";
import { classNames } from "@/helpers";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import SideBar from "./Sidebar";
import { useAppDetails } from "@/contexts/AppDetailsContext";
import Meta from "./Meta";
import { useRecoilValue } from "recoil";
import { timezoneAtom } from "@/Atoms/settings/TimezoneAtom";

interface LayoutProps {
  meta?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  className?: string;
  trainingComponent?: ReactNode;
  IdeasStream?: ReactNode;
  hideRiskWarning?: boolean;
  hideSpaceWhenNoRiskWarning?: boolean;
  hideIdeastream?: boolean;
  hideHeader?: boolean;
  hideSidebar?: boolean;
  onScrollBg?: boolean;
  showDisabled?: boolean;
}

export default function Layout(props: LayoutProps) {
  const modal = useModal();
  const router = useRouter();
  const globalLoading = useGlobalLoading();
  const { showSidebar } = useSidebarContext();
  const { details } = useAppDetails();
  const timezone = useRecoilValue(timezoneAtom);
  return (
    <>
      {globalLoading.loading ? (
        <div className="!h-[100vh] !w-full flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <div
          className={classNames(
            "antialiased w-full h-full flex flex-col loading-container ",
            globalLoading.loading ? "h-[100vh] overflow-hidden " : "",
            props.className,
          )}
        >
          <div className="relative h-0 -z-10">
            <span
              className="absolute invisible"
              style={{ fontFamily: `"Shoika"` }}
            >
              &nbsp;
            </span>
          </div>
          <div
            className={
              "transitions-all flex flex-col gap-1 duration-300 dark:bg-blue20 main-load h-full" +
              (modal.open ? "blur-sm" : "")
            }
          >
            {details.isWhiteLabled ? (
              <Meta
                title={details?.appName ?? ""}
                description={details?.brokerName}
              />
            ) : (
              props.meta
            )}
            {typeof props.header !== "undefined" ? (
              props.header
            ) : props?.hideHeader ? (
              <Header
                hideHeader={props?.hideHeader}
                onScrollBg={props?.onScrollBg}
                showDisabled={props?.showDisabled}
                hideSidebar={props?.hideSidebar}
              />
            ) : (
              <Header showDisabled={props?.showDisabled} hideSidebar={props?.hideSidebar} />
            )}

            <div className="flex  w-full h-full">
              {!props.hideSidebar && (
                <div className={""}>
                  <SideBar showDisabled={props?.showDisabled} />
                </div>
              )}
              <div
                key={timezone}
                className={cn(
                  "w-full min-h-[calc(100vh-135px)]  lg:min-h-[calc(100vh-140px)] xl:min-h-[calc(100vh-105px)] flex-grow overflow-auto", //  h-[calc(100vh-190px)] lg:h-[calc(100vh-134px)]  xl:h-[calc(100vh-100px)]
                  router.pathname?.includes("logout") ? "!w-full" : "",
                  showSidebar
                    ? "lg:w-[calc(100%-250px)]"
                    : "lg:w-[calc(100%-70px)]",
                  props.hideSidebar ? "!w-full !h-full" : "",
                )}
              >
                {props.children}
              </div>
            </div>
            <div className="p-3 bg-foreground text-primary-foreground text-xs absolute bottom-0 w-full hidden">
              New - Join the{" "}
              <Link
                href={`/creator-program?locale=${router.query.locale || "en"}`}
                className="underline font-bold"
              >
                Strategy Creator Program
              </Link>{" "}
              and turn your trading ideas into profit-generating strategies
            </div>
            {typeof props.trainingComponent !== "undefined"
              ? props.trainingComponent
              : ""}
            {typeof props.footer !== "undefined" ? props.footer : <Footer />}
          </div>
          <div id="intercom-custom"></div>
          <Dialog open={modal.open}>
            <DialogContent>{modal.body}</DialogContent>
          </Dialog>
        </div>
      )}
    </>
  );
}
